import React, { useContext, createContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { notification } from "antd";
import { CreditCardDetails, WandaPayment } from "../types/PaymentTypes";
import { getDefaultSavedPaymentInstrument } from "../services/PaymentService/PaymentInstrumentService";
import { usePersonSummaryCtx } from "./PersonSummaryContext";

export const PaymentDetailsContext = createContext<any | undefined>(undefined);

export const usePaymentDetailsCtx = () => useContext(PaymentDetailsContext);

export const PaymentDetailsProvider: React.FC = ({ children }) => {
  const [
    defaultSavedCreditCardDetails,
    setDefaultSavedCreditCardDetails,
  ] = useState<CreditCardDetails | null>();
  const [
    isDefaultSavedCreditCardExists,
    setIsDefaultSavedCreditCardExists,
  ] = useState<boolean>();

  const { pathname } = useLocation();

  const {
    isLoadingPersonData,
    caregiverSummaryInfo,
    isWandaConcierge,
  } = usePersonSummaryCtx();

  const getDefaultSavedCreditCard = async () => {
    try {
      const {
        data: creditCardDetails,
        status,
      } = await getDefaultSavedPaymentInstrument({
        paymentInstrumentType: WandaPayment.CreditCard,
        paymentGatewayType: WandaPayment.CyberSource,
        personId: isWandaConcierge ? caregiverSummaryInfo.personId : undefined,
      });

      if (status === 200) {
        setDefaultSavedCreditCardDetails(creditCardDetails);
        setIsDefaultSavedCreditCardExists(true);
      } else if (status === 404) {
        setIsDefaultSavedCreditCardExists(false);
        setDefaultSavedCreditCardDetails(null);
      }
    } catch (error: any) {
      notification.error({
        message: `Error ${error?.response?.status}`,
        description: "Failed to fetch Credit Card Details",
      });
    }
  };

  useEffect(() => {
    !isLoadingPersonData &&
      !["/Welcome"].includes(pathname) &&
      getDefaultSavedCreditCard();
  }, [isLoadingPersonData]);

  return (
    <PaymentDetailsContext.Provider
      value={{
        defaultSavedCreditCardDetails,
        isDefaultSavedCreditCardExists,
        getDefaultSavedCreditCard,
      }}
    >
      {children}
    </PaymentDetailsContext.Provider>
  );
};
